var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertMessageinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM10.75 9C10.75 8.58579 10.4142 8.25 10 8.25H7.75V9.75H9.25V13.25H7.75V14.75H12.25V13.25H10.75V9ZM9.25 6C9.25 5.58579 9.58579 5.25 10 5.25H10.0025C10.4167 5.25 10.7525 5.58579 10.7525 6C10.7525 6.41421 10.4167 6.75 10.0025 6.75H10C9.58579 6.75 9.25 6.41421 9.25 6Z",
    fill: "#2FA55C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertMessageinfo);
export default __webpack_public_path__ + "static/media/alertMessageinfo.b274eafc4b1edb5a541038424b84400f.svg";
export { ForwardRef as ReactComponent };